import { useForm } from 'react-hook-form';
import React, { useState, useEffect } from "react";
import Auth from "../../../service/Auth";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { useOrderStore } from 'src/hooks/order';
import CartRepository from 'src/repository/CartRepository';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AuthConfig from "@system/config/auth";
import { isArray } from 'underscore';
import QuoteDetailRepository from 'src/repository/QuoteDetailRepository';
import { useCartStore } from 'src/hooks/cart';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Helper from 'src/support/Helper';
import CheckOut from "@system/config/checkout";
import ReusableDiv from 'src/support/ReusableDiv';
import Constants from 'src/support/Constants';
import { useAuthStore } from 'src/hooks/auth';
import { useSelector } from "react-redux";
import {stepEventMaker} from "src/support/stepEventMaker";

const StepPaymentMethod = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const [{ CART_SHIPPING_ADDRESS_ID }, { get_cart_quote_number }, { add_cart_in_Bulk }] = useCartStore();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedInvoiceAddress, setSelectedInvoiceAddress] = useState('');
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    const [invoiceAddressList, setInvoiceAddressList] = useState([]);
    const [isPaymentBlocked, setIsPaymentBlocked] = useReduxState('', 'setIsPaymentBlocked');
    const [paymentBlocked, setPaymentBlocked] = useState('');
    const [isCreditRisk, setIsCreditRisk] = useReduxState('', 'setIsCreditRisk');
    const [isCreditRiskAlert, setCreditRiskAlert] = useReduxState('', 'setCreditRiskAlert');
    const [isPlaceOrder, setIsPlaceOrder] = useReduxState('', 'setIsPlaceOrder');
    const [isPONumber, setIsPONumber] = useReduxState('', 'setIsPONumber');
    const [isTermsCondition, setIsTermsCondition] = useReduxState('', 'setIsTermsCondition');
    const [invoiceAddressErr, setInvoiceAddressErr] = useState(false);
    const [partialdelivery, setPartialdelivery] = useState('');
    const [checkOutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [paymentMethodInfo, setPaymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [shippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [{ }, { }, { place_your_order }] = useOrderStore();
    const purchaseOrderPattern = /^.{1,35}$/g;
    const [invoiceMsgErr, setInvoiceMsgErr] = useReduxState(false, 'setInvoiceMsgErr');
    // For Quote
    const [{ get_current_quote_cart }, { }, { }] = useQuoteDetailStore();
    const [shippingInfoError] = useReduxState(false, 'setShippingInfoError')
    const [selectedCarrier] = useReduxState('', 'setSelectedCarrier');


    const quoteNumber = get_cart_quote_number();
    const speedBoatName = (System.auth('speedBoat') === 'T' ? 'Abacus' : System.auth('speedBoat') === 'B' ? 'EBV' : 'Silica')
    const [{  }, { get_customer_scope_information }, { }] = useAuthStore()
    const validateSpaceError = (value) => {
        if (value && value.trim().length > 0) {
            return true
        } else {
            return false
        }
    }


    const onSubmit = async (data) => {
        if (errors
            && Object.keys(errors).length === 0 && !shippingInfoError) {
            setIsPlaceOrder(true)
            if (_check_p('CHECKOUT_PLACE_ORDER_BUTTON').status === false && invoiceAddressErr === false) {
                Helper.scrollTop();
                System.alert('Avnet Employees are not allowed to place orders.', 'danger');
                return false;
            }

            if (isPaymentBlocked === true) {
                Helper.scrollTop();
                System.popup('ContactUsPlaceOrderPopup')
                return false;
            }

            let paymentMethodData = {
                poNumber: data.poNumber,
                cartId: await new CartRepository().getCartID()
            }

            if (quoteNumber && quoteNumber > 0) {
                const quoteList = get_current_quote_cart();
                const quoteCartList = await new QuoteDetailRepository().setAddToCartQuote(quoteList);
                const selectedProductData = await add_cart_in_Bulk(quoteCartList);
                if (selectedProductData && selectedProductData.payload && selectedProductData.payload[0].cartId) {
                    paymentMethodData.cartId = selectedProductData && selectedProductData.payload && selectedProductData.payload[0].cartId
                }
            }

            setPaymentMethodInfo(paymentMethodData)

            if (isCreditRisk === true) {
                Helper.scrollTop();
                /**
                 * Ticket #  : 9273
                 * Change #  : Credit Risk flag hide the banner of payment on close button
                 * Change By : Pankaj
                 * Date      : 17 Feb 2023 
                 */
                setCreditRiskAlert(true);
                // System.alert('Payment in advanced required.', 'warning');
                /**
                 * Make callback for the place order on click of ok
                 * Author: Devanshi Patel
                 */
                System.popup('RiskPlaceOrderPopup', { onClickOk: () => placeYourOrder(paymentMethodData) })
                return false;
            }
            checkOutStep3();
            await placeYourOrder(paymentMethodData)
        }
    }

      //By Ramya Kannan [Checkout-step3 ],[quote-step2]
      const CART_DATA = useSelector((state) => state.entities.Cart.CART_DATA);
      let quoteDetails = useSelector(
        (state) => state.entities.model_QuoteDetail.cart_quote_active_session
      );
      function checkOutStep3(){
          localStorage.setItem("adobeEventType","checkOut");
          const capitalizeFirstLetter = str => str[0].toUpperCase() + str.slice(1);
          let stepData = capitalizeFirstLetter(checkOutStepStatus)
          let checkOutStep = "checkout"+stepData;
          stepEventMaker(CART_DATA,quoteDetails,checkOutStep,quoteNumber);
      }

    const placeYourOrder = async (paymentMethodData = false) => {
        let params = {
            cartId: paymentMethodInfo.cartId ? paymentMethodInfo.cartId : '',
            pecEmail: '', //shippingAddressInfo.PECEmail ? shippingAddressInfo.PECEmail :
            sdiNumber: '', //shippingAddressInfo.SDICode ? shippingAddressInfo.SDICode : 
            shipToId: shippingAddressInfo.shippingAddress && shippingAddressInfo.shippingAddress.ship_to_id ? shippingAddressInfo.shippingAddress.ship_to_id : '',
            attn: shippingAddressInfo.ATTN ? shippingAddressInfo.ATTN : '',
            telephoneNumber: shippingAddressInfo.telephoneNumber ? shippingAddressInfo.telephoneNumber : '',
            purchaseOrderNumber: paymentMethodInfo.poNumber ? paymentMethodInfo.poNumber.trim() : '',
            sapQuoteNumber: (quoteNumber && quoteNumber > 0) ? quoteNumber : "",
            createdDate: new Date(),
            billTo: selectedInvoiceAddress.bill_to_id,
            wholeDelivery: partialdelivery,
            orderBlock: paymentBlocked,
            creditRisk: isCreditRisk,
            orderPlaced: true,
            carrierAccountNumber: selectedCarrier
        }
        if (paymentMethodData) {
            params.cartId = paymentMethodData.cartId ? paymentMethodData.cartId : ''
            params.purchaseOrderNumber = paymentMethodData.poNumber ? paymentMethodData.poNumber.trim() : ''
        }

        // when quote place order exists then clear quotes from session and manage accordingly is pending in development
        let placeOrder = await place_your_order(params)
        if (placeOrder && placeOrder.payload && Object.entries(placeOrder.payload).length > 0) {
            if (quoteNumber && quoteNumber > 0) {
                window.location.href = CheckOut.getCheckOutStatusRouteURL(Constants.systemModules.Quote) + '?orderId=' + placeOrder.payload.webOrderNumber;
            } else {
                const CART_COUNT_ss = "CART_COUNT_" + AuthConfig.getAccountNumber() + "_" + System.auth('salesOrg') + "_" + AuthConfig.getAuthSBoat()
                sessionStorage.removeItem(CART_COUNT_ss)
                window.location.href = CheckOut.getCheckOutStatusRouteURL() + '?orderId=' + placeOrder.payload.webOrderNumber;
            }
            sessionStorage.setItem('carrierAccountNumber',placeOrder?.payload?.carrierAccountNumber);
            sessionStorage.setItem(placeOrder.payload.webOrderNumber, true)
            sessionStorage.setItem("invoiceAddress", JSON.stringify(selectedInvoiceAddress))
        }
    }

    useEffect(() => {
        checkInvoiceError()
    }, [errors]);

    useEffect(() => {
        if (selectedInvoiceAddress === '' && invoiceAddressErr === true) {
            setInvoiceMsgErr(true)
        } else {
            setInvoiceMsgErr(false)
        }
    }, [selectedInvoiceAddress, invoiceAddressErr]);

    const checkInvoiceError = (isClick = false) => {
        setIsPONumber(false)
        setIsTermsCondition(false)

        if (selectedInvoiceAddress === '' && isClick === true) {
            setInvoiceAddressErr(true)
        }
        if (errors && Object.keys(errors).length > 0) {

            if (errors.poNumber) {
                setIsPONumber(true)
            }
            if (errors.tc) {
                setTimeout(() => {
                    setIsTermsCondition(true)
                }, 0.20);
            }
        }
    }
    useEffect(() => {
        async function fetchHere() {
            getPaymentMethods()
            await getInvoiceAddressList()
            await getPaymentMethodFromId(0)
        }
        setTimeout(() => {
            fetchHere()
        }, 500);

    }, []);

    const getPaymentMethods = async () => {
        setPaymentMethods([{ "name": 'Avnet Credit Line / ' + await AuthConfig.getAccountDescription() }])
    }

    const getInvoiceAddressList = async () => {
       let res = await get_customer_scope_information();
        if (res) {
            await setInvoiceAddressList(res?.payload?.data.bill_to)
            await setIsPaymentBlocked(res?.payload?.data.order_block)
            await setPaymentBlocked(res?.payload?.data.order_block)
            await setIsCreditRisk(res?.payload?.data.credit_risk)
            await setPartialdelivery(res?.payload?.data.partialdelivery)
        }

    };

    useEffect(() => {
        async function fetchHere() {
            await getInvoiceAddressFromId()
        }

        fetchHere()
    }, [CART_SHIPPING_ADDRESS_ID]);

    useEffect(() => {
        async function fetchHere() {
            if (selectedInvoiceAddress !== undefined && selectedInvoiceAddress !== '') {
                await getInvoiceAddressFromId(selectedInvoiceAddress)
            }
        }
        fetchHere()
    }, [selectedInvoiceAddress]);

    useEffect(() => {
        setSelectedPaymentMethod(paymentMethods[0])
    }, [selectedPaymentMethod]);

    useEffect(() => {
        if (invoiceAddressList && isArray(invoiceAddressList) && invoiceAddressList.length === 1) {
            setSelectedInvoiceAddress(invoiceAddressList[0].bill_to_id)
        }
    }, [invoiceAddressList]);

    const getInvoiceAddressFromId = async (selectedInvoiceAddress = '') => {
        let isBroken = false;
        invoiceAddressList !== undefined && isArray(invoiceAddressList) && invoiceAddressList.length > 0 &&
            invoiceAddressList.map((v) => {
                if (isBroken) {
                    return;
                }
                if (v.bill_to_id == (selectedInvoiceAddress !== undefined && selectedInvoiceAddress !== '' ? selectedInvoiceAddress : CART_SHIPPING_ADDRESS_ID)) {
                    setSelectedInvoiceAddress(v);
                    isBroken = true;
                    return;
                }
            })
    }

    const getPaymentMethodFromId = async (selectedPaymentMethod) => {
        let isBroken = false;
        paymentMethods !== undefined && isArray(paymentMethods) && paymentMethods.length > 0 &&
            paymentMethods.map((v) => {
                if (isBroken) {
                    return;
                }
                setSelectedPaymentMethod(v[selectedPaymentMethod !== undefined && selectedPaymentMethod !== '' ? parseInt(selectedPaymentMethod) : 0])
                isBroken = true;
            })
    }

    return (
        <>
            <div className={"shipping-method steps-inner mb-3 " + ((checkOutStepStatus.toLowerCase() === 'step2') ? 'active' : '')}>
                {ReusableDiv.checkoutStepTitle("2. Payment Method")}
                <div className="checkbox-steps-content">
                    <div className="step-complete-hide">
                        <div className="shipping-method-detail checkbox-steps-content p-0">
                            <div className="bs5 row">
                                <div className="col-12">
                                    <h3 className="mt-0">SELECTED PAYMENT METHOD:</h3>
                                    <div className="form-check mb-2">
                                        {(paymentMethods && paymentMethods.length > 0) &&
                                            paymentMethods.map((v, i) => (
                                                <div key={i}>
                                                    <input className="form-check-input" type="radio" name="payment-radio"
                                                        id={"payment-radio" + i}
                                                        checked={i == 0}
                                                        value={i}
                                                        onChange={(e) => {
                                                            setSelectedPaymentMethod(paymentMethods[0])
                                                        }} />
                                                    <label className="form-check-label" htmlFor={"payment-radio" + i}>
                                                        {v.name}
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                    <div className="info-text m-b-10">
                                        <p>
                                            For questions on your account or order, please contact your {speedBoatName} sales representative. For general support on My{speedBoatName}, please contact the EMEA Online Support Team at 00800 412 412 11 or via email: <a href="mailto:OnlineSupportEU@avnet.com">onlinesupportEU@avnet.com</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-0" />
                            <div className="row">
                                <div className="col-12 col-sm-12 col-lg-6 col-xl-6">
                                    <h3 className="mt-3">INVOICE ADDRESS:</h3>
                                    <span>Where do you want your invoice sent?</span>
                                    <div className="invoice-address">
                                        <p className="mb-2 mt-2"><b>Please select your invoice address</b></p>

                                        {(invoiceAddressList && invoiceAddressList.length > 0) &&
                                            invoiceAddressList.map((v, i) => (
                                                <div className="form-check mb-3" key={i}>
                                                    <input className="form-check-input" type="radio" name="address"
                                                        id={"address" + i}
                                                        value={v.bill_to_id}
                                                        checked={invoiceAddressList.length === 1 ? invoiceAddressList[0].bill_to_id : selectedInvoiceAddress.bill_to_id === v.bill_to_id}
                                                        onChange={(e) => {
                                                            setSelectedInvoiceAddress(e.target.value)
                                                        }} />
                                                    <label className="form-check-label" htmlFor={"address" + i}>
                                                        <b>{v.name}</b>
                                                        <span className="d-block">{v.address_line}<br />
                                                            {v.city_name}, {v.country_subDivision_code} {v.postal_code}<br />
                                                            {v.country_code}</span>
                                                    </label>
                                                </div>
                                            ))
                                        }
                                        <p className="error mb-0">{selectedInvoiceAddress === '' && invoiceAddressErr === true && "Please select invoice address to proceed"}</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="mt-0 mb-4" />
                            <div className="alert alert-warning text-center justify-content-center py-2" role="alert">
                                <span>The exact freight amount and Tax will be calculated at the time shipment is
                                    processed
                                    and will appear on your shipment notifications.</span>
                            </div>
                            <div className="bs5 row">
                                <div className="col-12 col-sm-12 col-lg-6 col-xl-5 ms-auto">
                                    <form id="hook-form" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-group m-b-30">
                                            <label htmlFor="order-num" className="form-label">Purchase Order Number* <i className='font-12'>(required)</i></label>
                                            <input type="text" className="form-control" id="order-num"
                                                aria-describedby="emailHelp" placeholder="ie. 1234567654321"
                                                {...register("poNumber", { required: true, pattern: purchaseOrderPattern, validate: (value) => validateSpaceError(value) })} maxLength={35} />
                                            <p className="error mb-0">{errors.poNumber?.type === 'required' && "Enter a Purchase Order Number"}</p>
                                            <p className="error mb-0">{errors.poNumber?.type === 'pattern' && "Purchase Order Number is not valid"}</p>
                                            <p className="error mb-0">{errors.poNumber?.type === 'validate' && "Purchase Order Number is not valid"}</p>
                                        </div>
                                        <div className="form-check text-start ms-auto">
                                            <label className="form-check-label">
                                                <input className="form-check-input float-none me-1 border-black" type="checkbox"
                                                    id="tc" {...register("tc", { required: true })} />
                                                <span className="p-l-05">*I have read and agree to the </span>
                                            </label>
                                            <a className='text-blue2 p-l-05'
                                                href='https://www.avnet.com/wps/portal/emea/about-us/terms-and-conditions-of-purchase/' target="_blank">
                                                terms and conditions</a>
                                        </div>
                                        <p className="error mb-0">{errors.tc?.type === 'required' && "Check Terms and Conditions"}</p>

                                        {__check(['PLACE_ORDER_API_CALL']).status &&
                                            <button type="submit" className="bs5 btn btn-primary btn-sm mt-5 d-block ms-auto w130" disabled={true}>
                                                <i className="placeorder-spinner fa-spin" />
                                            </button>
                                        }

                                        {!__check(['PLACE_ORDER_API_CALL']).status &&
                                            <button type="submit" className="bs5 btn btn-primary btn-sm mt-5 d-block ms-auto w130"
                                                onClick={() => checkInvoiceError(true)}
                                                disabled={paymentBlocked === true && isPlaceOrder === true || (selectedInvoiceAddress === '' && invoiceAddressErr === true) ? true : false}
                                            >Place Order
                                            </button>}
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StepPaymentMethod;